export default {
  initiated: false
}
